import {
  createBaseThemeOptions,
  createUnifiedTheme,
  palettes,
  genPageTheme,
} from '@backstage/theme';
import InterRegular from '../assets/fonts/Inter-Regular.ttf';

const interRegularFont = {
  fontFamily: 'Inter-Regular',
  fontStyle: 'normal',
  fontWeight: 400,
  src: `
    local('Inter-Regular'),
    url(${InterRegular}) format('woff2'),
  `,
};

export const kdsLightTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: {
        main: '#1450f5',
      },
      secondary: {
        main: '#f3eee6',
      },
      error: {
        main: '#ff5f28',
      },
      warning: {
        main: '#ffa023',
      },
      info: {
        main: '#4373f7',
      },
      success: {
        main: '#1ed273',
      },
      background: {
        default: '#F5F8FF',
        paper: '#F5F8FF',
      },
      banner: {
        info: '#4373f7',
        error: '#ff5f28',
        text: '#141414',
        link: '#4373f7',
      },
      border: '#959595',
      errorBackground: '#ff5f28',
      warningBackground: '#ffa023',
      infoBackground: '#4373f7',
      navigation: {
        background: '#ffffff',
        indicator: '#F5F8FF',
        color: '#141414',
        selectedColor: '#1450F5',
        navItem: {
          hoverBackground: '#F5F8FF',
        },
        submenu: {
          background: '#F5F8FF',
        },
      },
    },
  }),
  fontFamily: 'Inter-Regular, Arial, sans-serif',
  typography: {
    htmlFontSize: 14,
    fontFamily: 'Inter-Regular, Arial, sans-serif',
    h1: {
      fontSize: 58,
      fontWeight: 700,
      marginBottom: 10,
    },
    h2: {
      fontSize: 48,
      fontWeight: 700,
      marginBottom: 8,
    },
    h3: {
      fontSize: 40,
      fontWeight: 700,
      marginBottom: 6,
    },
    h4: {
      fontSize: 32,
      fontWeight: 700,
      marginBottom: 6,
    },
    h5: {
      fontSize: 28,
      fontWeight: 700,
      marginBottom: 4,
    },
    h6: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 2,
    },
  },
  defaultPageTheme: 'home',
  pageTheme: {
    home: genPageTheme({
      colors: ['#ffffff', '#ffffff'],
      shape: 'none',
      options: { fontColor: '#141414' },
    }),
    documentation: genPageTheme({
      colors: ['#ffffff', '#ffffff'],
      shape: 'none',
      options: { fontColor: '#141414' },
    }),
    tool: genPageTheme({
      colors: ['#ffffff', '#ffffff'],
      shape: 'none',
      options: { fontColor: '#141414' },
    }),
    service: genPageTheme({
      colors: ['#ffffff', '#ffffff'],
      shape: 'none',
      options: { fontColor: '#141414' },
    }),
    website: genPageTheme({
      colors: ['#ffffff', '#ffffff'],
      shape: 'none',
      options: { fontColor: '#141414' },
    }),
    library: genPageTheme({
      colors: ['#ffffff', '#ffffff'],
      shape: 'none',
      options: { fontColor: '#141414' },
    }),
    other: genPageTheme({
      colors: ['#ffffff', '#ffffff'],
      shape: 'none',
      options: { fontColor: '#141414' },
    }),
    app: genPageTheme({
      colors: ['#ffffff', '#ffffff'],
      shape: 'none',
      options: { fontColor: '#141414' },
    }),
    apis: genPageTheme({
      colors: ['#ffffff', '#ffffff'],
      shape: 'none',
      options: { fontColor: '#141414' },
    }),
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '@font-face': [interRegularFont],
      },
    },
    BackstageHeader: {
      styleOverrides: {
        header: ({ theme }) => ({
          width: 'auto',
          margin: 'none',
          padding: '16px 8px',
          boxShadow: 'none',
          borderBottom: `1px solid ${theme.palette.border}`,
        }),
      },
    },
  },
});
